export default {
  props: {
    headIcon: {
      type: String,
      default: require("./images/default.png")
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeName: this.defaultShow ? "1" : ""
    };
  }
};